import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  outline: "none",
  pt: 2,
  px: 4,
  pb: 3,
};

const Unauthenticated = () => {
  const { instance} = useMsal();

  const handleSignOut = async () => {
        setTimeout( () => {
          instance.logoutRedirect();
        }, 3000);
};
  return (
    <Modal
      open={true}
      onClose={() => handleSignOut()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Alert !
        </Typography>
        <Typography id="modal-modal-description" sx={{ m: 2,fontSize:"12px" }}>
          <p>You donot have access to this site please contact administrator</p>
        </Typography>
        <Button
            sx={{backgroundColor:" #212129",color:"white",display:"flex",float:"right"}}
            variant="contained"
            
            onClick={() => handleSignOut()}
          >
            Ok
          </Button>
      </Box>
    </Modal>
  );
};

export default Unauthenticated;
